import * as React from 'react';
import { UserAvatar } from '@balance-web/avatar';
import { ChevronDownIcon, ChevronUpIcon } from '@balance-web/icon';
import { Text } from '@balance-web/text';
import { Flex } from '@balance-web/flex';
import { Box } from '@balance-web/box';
import { Inline } from '@balance-web/inline';
import { Hidden } from '@balance-web/media-query';

import { ActionMenu } from '../ActionMenu';
import type { ActionMenuProps } from '../ActionMenu';

export type UserMenuProps = {
  username: string;
  version?: string;
} & Omit<ActionMenuProps, 'trigger'>;

export const UserMenu = ({ username, version, menuItems }: UserMenuProps) => {
  return (
    <Flex alignItems="center" flexGrow={0}>
      <ActionMenu
        footer={
          (!!version && (
            <Inline alignY="center" paddingTop="small" paddingX="large">
              <Text color="muted" size="xsmall">
                Version: {version}
              </Text>
            </Inline>
          )) ||
          null
        }
        menuItems={menuItems}
        trigger={({ triggerProps, isOpen }) => {
          const Icon = isOpen ? ChevronUpIcon : ChevronDownIcon;
          return (
            <Flex
              alignItems="center"
              as="button"
              cursor="pointer"
              type="button"
              userSelect="none"
              {...triggerProps}
            >
              <UserAvatar name={username} size="small" />
              <Hidden below="small">
                <Box marginX="small">
                  <Text
                    align="left"
                    overflowStrategy="nowrap"
                    size="small"
                    weight="medium"
                  >
                    {username}
                  </Text>
                </Box>
              </Hidden>
              <Icon color="muted" size="small" />
            </Flex>
          );
        }}
      />
    </Flex>
  );
};
